'use client';
import { lazy, type ComponentProps } from 'react';
export type * from "/tmp/build-252/overrides/components/categories/subcategories-cards.tsx";
const Deferred0 = lazy(() => import("@eliadmin/page-island-original/d09f16cce070").then(m => ({ default: m.SubcategoriesCards })));
const Island0 = ((props: NonNullable<ComponentProps<typeof import("/tmp/build-252/overrides/components/categories/subcategories-cards.tsx").SubcategoriesCards>>) => <Deferred0 {...props} />) as typeof import("/tmp/build-252/overrides/components/categories/subcategories-cards.tsx").SubcategoriesCards;
export { Island0 as SubcategoriesCards };
